import { Outlet } from "react-router-dom";
import { Footer, Header, SideBar } from "components/base";

const Layout: React.FC = () => {
  return (
    <div className="min-h-full flex flex-col">
      <Header />
        <main className="flex  flex-row">
          <div className="mt-12 md:block hidden">
            <SideBar />
          </div>
          <div className="md:ml-60 w-full h-screen px-2 sm:px-4 mt-14 mb-8 overflow-y-scroll">
            <span><Outlet /></span>
          </div>
        </main>
      <Footer/>
    </div>
  );
};

export default Layout;
